type DataOptionsIconProps = {
  className?: string;
};

export const DataOptionsIcon = ({ className }: DataOptionsIconProps) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ '--icon-color': 'currentColor' } as React.CSSProperties} // default
    >
      <defs>
        <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="gradient">
          <stop style={{ stopColor: 'var(--icon-color)', stopOpacity: 0.1 }} offset="0%" />
          <stop style={{ stopColor: 'var(--icon-color)', stopOpacity: 0.05 }} offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <rect fill="url(#gradient)" fillRule="nonzero" width="56" height="56" rx="12" />
        <path
          d="M28 22.667c6.627 0 12-1.791 12-4 0-2.21-5.373-4-12-4s-12 1.79-12 4c0 2.209 5.373 4 12 4z"
          stroke="var(--icon-color)"
          strokeWidth="2.667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 18.667v18.666c0 1.061 1.264 2.079 3.515 2.829 2.25.75 5.302 1.171 8.485 1.171s6.235-.421 8.485-1.171c2.25-.75 3.515-1.768 3.515-2.829V18.667"
          stroke="var(--icon-color)"
          strokeWidth="2.667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 28c0 1.06 1.264 2.078 3.515 2.828C21.765 31.578 24.817 32 28 32s6.235-.421 8.485-1.172C38.735 30.078 40 29.061 40 28"
          stroke="var(--icon-color)"
          strokeWidth="2.667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
